export const formatNumberToString = value =>
  value ? String(value).replace('.', ',') : '';
export const parseStringToNumber = value =>
  value ? value.replace(',', '.') : null;
export const isValidCharacter = char => /[0-9.,]/.exec(char);
